module.exports = __webpack_public_path__ + "img/A_ezplan4.f6747ee1.png";